import React, { FC } from 'react';
import { IFinalPrice } from 'utils/price.util';
import { ReactComponent as Savings } from 'assets/svgs/savings.svg';
import { useTranslation } from 'react-i18next';
import SummaryRowTypes from 'common/OrderSummary/components/OrderSummaryRow/row.types';
import { StyledBox, StyledOrderSummaryRow, TotalSavingsLabel } from './CheckoutTotalSavings.style';

const CheckoutTotalSavings: FC<{ totalSavings: IFinalPrice }> = ({ totalSavings }) => {
  const { t } = useTranslation();
  return totalSavings.value > 0 ? (
    <StyledBox>
      <StyledOrderSummaryRow
        label={
          <TotalSavingsLabel>
            <Savings /> {t('totalSavings')}
          </TotalSavingsLabel>
        }
        testId="total-saving-heading"
        variant={SummaryRowTypes.header}
        priceDetails={totalSavings}
        isDiscount
      />
    </StyledBox>
  ) : (
    <></>
  );
};

export default CheckoutTotalSavings;
